import { getIn } from "final-form";
import {
  validateCompanyDocs,
  validateCompanyFields,
  validateGstDetails,
} from "../CompanyDetails/companyDetailsHelper";
import { validateDirectorFields } from "../Director/directorHelper";
import { investmentFormValidation } from "../Investments/investementHelper";
import { revenueFormValidation } from "../Revenue Details/revenueHelper";
import { bankStatementValidation } from "../UploadDocuments/UploadDocuments";
import { processingStatus } from "../UploadDocuments/BankStatements";
import { ApplicationContextType } from "../../../interfaces/interfaces";
import { bankStatementValidator } from "../../MonthlyReport/BankStatement/bankStatementHelper";
import _ from "lodash";
import { validateBusinessUpdateStep } from "../../MonthlyReport/BusinessUpdates/businessUpdate.helper";

export const getAccountConnectionInfo = (accounts: any[]) => {
  console.log("accounts", accounts);
  if (!accounts.length) {
    return {
      successDetails: {
        message: `${accounts.length} accounts connected.`,
      },
      isError: true,
      errorDetails: {
        message: "No sales channel has been connected.",
      },
    };
  } else {
    const salesConnected = accounts.some((account) => account.isSalesChannel);
    return {
      successDetails: {
        message: `${accounts.length} accounts connected.`,
      },
      isError: salesConnected ? false : true,
      errorDetails: {
        message: "No sales channel has been connected.",
      },
    };
  }
};

export const getBankStatementErrorInfo = (
  values,
  underwritingFileJobs,
  statementJobs,
  formType = ApplicationContextType.underwriting
) => {
  // const { allErrors } = bankStatementValidation(
  //   values,
  //   underwritingFileJobs,
  //   statementJobs
  // );
  const { allErrors } = bankStatementValidator(
    values,
    underwritingFileJobs,
    statementJobs,
    formType
  );

  const { rootError, statementError, passwordError } = allErrors;

  let isStatementLoading = false;
  // const processingStatus
  if (values?.bankStatements && values?.bankStatements?.length) {
    isStatementLoading = values?.bankStatements.some((statement) => {
      const statementId = statement?.statementJobId;
      const statementType = statement?.statementType;
      const statementJob = getIn(
        statementJobs,
        `${statementId}.${statementType}`
      );
      // console.log("statementJob", statementJob);
      if (statementJob && processingStatus.has(statementJob.status)) {
        return true;
      }
    });
  }

  console.log();

  if (isStatementLoading) {
    return {
      successDetails: {
        message: "Processing statement...",
      },
      isError: false,
      errorDetails: {
        message: "",
      },
      isLoading: true,
    };
  } else if (rootError.length) {
    return {
      successDetails: {
        message: "",
      },
      isError: true,
      errorDetails: {
        message: "Missing bank statements.",
      },
    };
  } else if (statementError.length) {
    return {
      successDetails: {
        message: "",
      },
      isError: true,
      errorDetails: {
        message: "Uploaded statement is invalid or couldn’t be processed.",
      },
    };
  } else if (passwordError.length) {
    return {
      successDetails: {
        message: "",
      },
      isError: true,
      errorDetails: {
        message: "Uploaded statement is password-protected.",
      },
    };
  } else {
    const bankStatementLength = values?.bankStatements?.length;
    return {
      successDetails: {
        message: bankStatementLength
          ? `${bankStatementLength} ${
              bankStatementLength?.length > 1 ? "accounts" : "account"
            } added.`
          : "",
      },
      isError: false,
      errorDetails: {
        message: "",
      },
    };
  }
};

export const getCompanyDetailsErrorInfo = (
  values,
  underwritingFileJobs,
  gstAnalysisJobs,
  formType
) => {
  const { missingData } = validateCompanyFields(values);
  const { missingDocs, requirePassword } = validateCompanyDocs(
    values,
    underwritingFileJobs
  );

  const { errors, allErrors } = validateGstDetails(
    values,
    underwritingFileJobs,
    {},
    gstAnalysisJobs,
    formType
  );

  console.log("gst All errors", allErrors);

  if (missingData.length) {
    return {
      successDetails: {
        message: "",
      },
      isError: true,
      errorDetails: {
        message: "Details are incomplete.",
      },
    };
  } else if (missingDocs.length || allErrors?.missingDocs?.length) {
    return {
      successDetails: {
        message: "",
      },
      isError: true,
      errorDetails: {
        message: "Some documents are missing.",
      },
    };
  } else if (requirePassword.length || allErrors?.requirePassword?.length) {
    return {
      successDetails: {
        message: "",
      },
      isError: true,
      errorDetails: {
        message: "Some documents are password-protected.",
      },
    };
  } else if (allErrors?.isLoading) {
    return {
      successDetails: {
        message: "Verifying GST...",
      },
      isError: false,
      errorDetails: {
        message: "",
      },
      isLoading: true,
    };
  } else if (allErrors?.gstsUnverified?.length) {
    return {
      successDetails: {
        message: "",
      },
      isError: true,
      errorDetails: {
        message: `${allErrors?.gstsUnverified.length} GST(s) unverified.`,
      },
    };
  } else {
    return {
      successDetails: {
        message: "All complete.",
      },
      isError: false,
      errorDetails: {
        message: "",
      },
    };
  }
};

export const getDirectorDetailsErrorInfo = (values, underwritingFileJobs) => {
  const { missingData, requirePassword, missingDocs } = validateDirectorFields(
    values,
    underwritingFileJobs
  );

  if (missingData.length) {
    return {
      successDetails: {
        message: "",
      },
      isError: true,
      errorDetails: {
        message: "Details are incomplete.",
      },
    };
  } else if (missingDocs.length) {
    return {
      successDetails: {
        message: "",
      },
      isError: true,
      errorDetails: {
        message: "Some documents are missing.",
      },
    };
  } else if (requirePassword.length) {
    return {
      successDetails: {
        message: "",
      },
      isError: true,
      errorDetails: {
        message: "Some documents are password-protected.",
      },
    };
  } else {
    const directorLength = values?.directors?.length;
    return {
      successDetails: {
        message: `${directorLength} directors added.`,
      },
      isError: false,
      errorDetails: {
        message: "",
      },
    };
  }
};

export const getRevenueDetailsErrorInfo = (values, underwritingFileJobs) => {
  const { missingData, missingDocs, requirePassword } = revenueFormValidation(
    values,
    underwritingFileJobs
  );

  if (missingData.length) {
    return {
      successDetails: {
        message: "",
      },
      isError: true,
      errorDetails: {
        message: "Details are incomplete.",
      },
    };
  } else if (missingDocs.length) {
    return {
      successDetails: {
        message: "",
      },
      isError: true,
      errorDetails: {
        message: "Financials missing.",
      },
    };
  } else if (requirePassword.length) {
    return {
      successDetails: {
        message: "",
      },
      isError: true,
      errorDetails: {
        message: "Some documents are password-protected.",
      },
    };
  } else {
    return {
      successDetails: {
        message: "All complete.",
      },
      isError: false,
      errorDetails: {
        message: "",
      },
    };
  }
};

export const getInvestmentDetailsErrorInfo = (values) => {
  const { missingData } = investmentFormValidation(values);

  if (missingData.length) {
    return {
      successDetails: {
        message: "",
      },
      isError: true,
      errorDetails: {
        message: "Details are incomplete.",
      },
    };
  } else {
    return {
      successDetails: {
        message: "All complete.",
      },
      isError: false,
      errorDetails: {
        message: "",
      },
    };
  }
};

export const getSalesMarketingErrorInfo = (values) => {
  const adSpendsData = _.get(values, "salesAndAdSpends.Ad Spends", []);
  const salesData = _.get(values, "salesAndAdSpends.Net Sales", []);

  return {
    successDetails: {
      message: `${salesData?.length} sales channels added. ${adSpendsData?.length} ad channels added.`,
    },
    isError: false,
    errorDetails: {
      message: "",
    },
  };
};

export const getBusinessUpdatesErrorInfo = (values, monthYear) => {
  const { allErrors } = validateBusinessUpdateStep(values, monthYear);

  if (allErrors?.missingData?.length) {
    return {
      successDetails: {
        message: "",
      },
      isError: true,
      errorDetails: {
        message: "Details are incomplete.",
      },
    };
  } else {
    return {
      successDetails: {
        message: "All complete.",
      },
      isError: false,
      errorDetails: {
        message: "",
      },
    };
  }
};

export const getGstStepErrorInfo = (
  values,
  underwritingFileJobs,
  gstAnalysisJobs,
  formType
) => {
  const { allErrors } = validateGstDetails(
    values,
    underwritingFileJobs,
    {},
    gstAnalysisJobs,
    formType
  );

  const { missingDocs, gstsUnverified, requirePassword } = allErrors;

  if (gstsUnverified.length) {
    return {
      successDetails: {
        message: "",
      },
      isError: true,
      errorDetails: {
        message: `${gstsUnverified.length} GST(s) unverified.`,
      },
    };
  } else if (missingDocs.length) {
    return {
      successDetails: {
        message: "",
      },
      isError: true,
      errorDetails: {
        message: "GST certificate(s) missing.",
      },
    };
  } else if (requirePassword.length) {
    return {
      successDetails: {
        message: "",
      },
      isError: true,
      errorDetails: {
        message: "GST certificate(s) are password-protected.",
      },
    };
  } else {
    const gstLength = values?.gstDetails?.length;
    return {
      successDetails: {
        message: `${gstLength} GSTs added.`,
      },
      isError: false,
      errorDetails: {
        message: "",
      },
    };
  }
};
